export default function HeadingBrief({ title }) {
  return (
    <div>
      <div className="row">
        <h2 className="fw-bold">
          <span className="cf-header px-2">
            Creatifa <span className="text-capitalize">{title}</span> Brief
          </span>
        </h2>
      </div>
      <div className="row">
        <p>
          Jelaskan selengkap-lengkapnya desain yang Anda inginkan dengan mengisi
          form brief ini.
        </p>
      </div>
    </div>
  );
}
